import React from 'react'

import { ReactComponent as AgLoader } from '../../../assets/images/agb-loader.svg'
import './Loader.scss'

const Loader: React.FC = () => {
  return (
    <div className="loader">
      <div>
        <AgLoader className="loader-icon" />
      </div>
      <div>
        <p>Loading...</p>
      </div>
    </div>
  )
}

export default Loader
